// extracted by mini-css-extract-plugin
module.exports = {"altTextInputWrapper":"index-module__altTextInputWrapper___3nV4E"};